import AppConstants from '../../../../config/app.constants';

class ContactRequestController {
    /*@ngInject*/
    constructor(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, ContactRequestService, RouteService, CustomerService,
        $state, LocationService, DataCounter, Navigation, UserBranchService, $rootScope) {
        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.ContactRequestService = ContactRequestService;
        this.RouteService = RouteService;
        this.CustomerService = CustomerService;
        this.LocationService = LocationService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.Navigation = Navigation;
        this.UserBranchService = UserBranchService;
        this.$q = $q;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            contactRequestObj: {
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            locationListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            loggedInUser: User.getUser().id,
            branchId: User.getUser().branchId,
            customerId: null,
            userBranchList: [],
            timezone: null,
            isExporting: false,
            currentStats: 'pending',
            isCompleted: 0
        };

        this.routeLocalLang = {
            nothingSelected: this.$translate.instant('checkout.selectRoute'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        }
        this.locationLocalLang = {
            nothingSelected: this.$translate.instant('branch_mgmt.items.locations'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };
        this.branchLocalLang = {
            nothingSelected: this.$translate.instant('common.selectBranch'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };

        this.stats = {
            pending: 'pending',
            completed: 'completed'
        }
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/contact-request');
    }

    $onInit() {
        this.model.loading = true;

        this.$q.all([
            this.SetupService.get(this.model.branchId),
            this.UserBranchService.getUserBranches(this.model.loggedInUser),
            this.routesAndLocationList()
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.userBranchList = data[1].results;

                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                })

                this.model.vaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);
                this.loadDateRangePicker(this.model.vaultDate, this.model.dateRangeOptions, 'dateRange');
                this.model.dateRangeOptions.startDate = moment(this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
                this.model.dateRangeOptions.endDate = moment(this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');
                this.loadData();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    loadDateRangePicker(date, dateRangeOption, modelVal) {
        let currentVaultDate = moment(date).format() || moment();
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.reset();
                    this.loadData();
                }
            },
            ranges: {
                'Running 45 Days': [
                    moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Year': [
                    moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    goToServiceHistory(locationId) {
        const obj = {
            locationId: locationId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
    }

    exportReports() {
        const startDate = this.getStartDate();
        const endDate = this.getEndDate();
        const branchIds = this.getSelectedBranches();
        const routeId = this.getSelectedRoutes();
        const locationId = this.getSelectedLocations();
        const title = !this.model.isCompleted ? 'Pending_contact_request_' : 'Completed_contact_request_';
        const reportPrefix = `${title}(${startDate}_${endDate})`;

        this.model.isExporting = true;
        this.ContactRequestService.exportContactRequest(branchIds, routeId, locationId, startDate, endDate, this.model.isCompleted)
            .then((data) => {
                this.downloadFile(reportPrefix, data.reportData)
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.model.isExporting = false;
            })
    }

    reset() {
        this.model.contactRequestObj.pagination.page = 1;
    }

    resetLocationAndRoute() {
        setTimeout(() => {
            this.model.locationId = [];
            this.model.routeId = [];
        })
    }

    routesAndLocationList() {
        setTimeout(() => {
            const branchId = this.getSelectedBranches();

            this.model.loadingList = true;
            this.ContactRequestService.routesAndLocationList(branchId)
                .then((data) => {
                    this.model.contactRequestObj.routeList = this.dataMapping(data.routes, 'routeId', 'routeName');
                    this.model.contactRequestObj.locationList = this.dataMapping(data.locations, 'locationId', 'locationName');
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.loadingList = false;
                })
        })
    }

    loadData() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const routeId = this.getSelectedRoutes();
            const locationId = this.getSelectedLocations();
            const branchId = this.getSelectedBranches();

            this.model.contactRequestObj.loading = true;
            this.ContactRequestService.contactRequest(branchId, routeId, locationId, startDate, endDate, this.model.isCompleted,
                (this.model.contactRequestObj.pagination.page - 1) * this.model.contactRequestObj.pagination.pageLimit,
                this.model.contactRequestObj.pagination.pageLimit)
                .then((data) => {
                    this.model.contactRequestObj.results = data.results;
                    this.model.contactRequestObj.pagination.total = data.total;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.contactRequestObj.loading = false;
                })
        })
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    getSelectedRoutes() {
        return Array.isArray(this.model.routeId) ? this.model.routeId.map((r) => r.Value) : null;
    }

    getSelectedLocations() {
        return Array.isArray(this.model.locationId) ? this.model.locationId.map((l) => l.Value) : null;
    }

    goToServiceHistory(locationId) {
        return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }

    goToRouteTab(routeId, vaultDate) {
        return this.Navigation.goToRouteTab(routeId, vaultDate, true, null);
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
    }

    printReport() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const routeId = this.getSelectedRoutes();
            const locationId = this.getSelectedLocations();
            const branchId = this.getSelectedBranches();

            this.model.isPrint = true;
            this.ContactRequestService.contactRequest(branchId, routeId, locationId, startDate, endDate, this.model.isCompleted, 0, 5000)
                .then((data) => {
                    let url = this.$state.href('contactRequestPrint');
                    window.w = window.open(url, '_blank');
                    window.w.printData = {
                        results: data.results, startDate, endDate, isCompleted: this.model.isCompleted
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.isPrint = false;
                })
        })
    }

    dataMapping(data, value, label) {
        return data.map((d) => {
            return {
                Key: d[value] + ' | ' + d[label],
                Value: d[value]
            }
        });
    }

    pageChange() {
        this.loadData();
    }

    markCompleteContactRequest(id) {
        this.model.markComplete = true;
        this.Modal.confirmSupervisor('mark-complete-contact-request', null, ({ modal, supId }) => {
            this.ContactRequestService.markCompleteContactRequest(id, supId)
                .then(() => {
                    this.loadData();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    modal.close();
                    this.model.markComplete = false;
                })
        }, ({ modal }) => {
            modal.close();
            this.model.markComplete = false;
        })
    }

    tabSelection() {
        this.model.contactRequestObj.pagination.page = 1;
        if (this.model.currentStats === this.stats.pending) this.model.isCompleted = 0;
        else if (this.model.currentStats === this.stats.completed) this.model.isCompleted = 1;
        this.loadData();
    }
}

export default ContactRequestController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/contact_request/contact_request.controller.js